import React, { useCallback, useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { useGetSubjectsQuery, useUpdateSubjectIndexesMutation } from '../../app/services/subjectApi';
import HelperTooltip from '../resources/helperTooltip/HelperTooltip';
import SubjectRow from './SubjectRow';
import produce from 'immer';
import AddSubject from './AddSubject';
import { useTranslation } from 'react-i18next';

type UpdateSubjectIndexed = {
  subjectId: string,
  indexed: boolean
}

const ManageSubjects: React.FC = () => {
  const { data, isSuccess, isError } = useGetSubjectsQuery();
  const { t:_ } = useTranslation();

  // TODO: INCLUDE MUTATIONS (ADD, DELETE, UPDATE SUBJECT)
  const [updateSubjects, { isLoading }] = useUpdateSubjectIndexesMutation()
  const [subjectUpdateIndexed, setSubjectUpdateIndexed] = useState<UpdateSubjectIndexed[]>([])

  const updateSaveList = useCallback((id: string, value: boolean) => {
    setSubjectUpdateIndexed(produce(subjectUpdateIndexed, (draft) => {
      const itemToUpdate = draft.find((item) => item.subjectId === id)

      if (itemToUpdate) {
        itemToUpdate.indexed = value;
      } else {
        draft.push({ subjectId: id, indexed: value});
      }
    }))
  }, [subjectUpdateIndexed])

  const saveNewIndexedValues = async () => {
    await updateSubjects({ subjects: subjectUpdateIndexed})
  }

  return (
    <div className="h-100 d-flex flex-column">
      <h1>{_("manageSubject.heading")}</h1>
      <p>{_("manageSubject.introduction")}</p>
      <AddSubject />
      <div className="h-100 overflow-auto mt-4">
        {isError ? (
          <p>{_("manageSubject.error")}</p>
        ) : isSuccess ? (
          <table>
            <thead>
              <tr>
                <th>{_("manageSubject.subject")}</th>
                <th className="pe-3">{_("manageSubject.indexed")} <HelperTooltip tooltipText={_("manageSubject.indexTooltip")}/></th> {/** TODO: ADD HELPER TOOLTIP EXPLAINING INDEXED MEANING */}
                <th>{_("manageSubject.dateCreated")}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {data.subjects.map((subject) => (
                <SubjectRow key={subject.id} subject={subject} updateSaveList={updateSaveList} />
              ))}
            </tbody>
          </table>
        ) : (
          <p>{_("Loading")}...</p>
        )}
        { /** TODO: INCLUDE ADD BUTTON TO LOAD NEW SUBJECT FORM MODAL */}
        { /** TODO: INCLUDE INFORMATION ABOUT NUMBER OF SUBJECTS */}
      </div>
      { /** MAKE BUTTONS ONLY APPEAR IF CHANGES MADE TO INDEXED VALUES */ }
      { subjectUpdateIndexed.length > 0 && (
        <div className="d-flex flex-row justify-content-end gap-2 m-3">
          <Button className="" variant='outline-editing'>{_("manageSubject.cancel")}</Button>
          <Button className="" disabled={isLoading} variant='editing' onClick={() => saveNewIndexedValues()}>
            { isLoading ? <Spinner size='sm'/> : _("manageSubject.saveChanges")}
          </Button>
        </div>
      )}
    </div>
  )
}

export default ManageSubjects;
